import { Link, useLocation } from "react-router-dom";

const recommended = [
  { to: "/news", label: "娱乐资讯", icon: "ri-newspaper-line" },
  { to: "/original", label: "趣味原创", icon: "ri-quill-pen-line" },
  { to: "/video", label: "视频专区", icon: "ri-play-circle-line" },
  { to: "/community", label: "互动社区", icon: "ri-chat-smile-2-line" },
];

export default function NotFound() {
  const location = useLocation();

  return (
    <div className="mx-auto flex max-w-7xl flex-col items-center px-4 py-16 text-center md:px-6 md:py-24">
      <div className="relative">
        <span className="select-none font-heading text-[100px] font-black leading-none text-primary-100 md:text-[160px]">
          404
        </span>
        <span className="absolute inset-0 flex items-center justify-center">
          <span className="flex h-16 w-16 items-center justify-center rounded-full bg-primary-500 text-background-50 dark:text-foreground-950">
            <i className="ri-emotion-sad-line text-3xl"></i>
          </span>
        </span>
      </div>
      <h1 className="mt-6 font-heading text-xl font-bold text-foreground-950 md:text-2xl">
        哎呀，这个页面好像走丢了
      </h1>
      <p className="mt-3 max-w-md text-sm text-foreground-500 md:text-base">
        你访问的内容不存在，或链接已经失效。别急，下面的入口可以带你回到热闹的地方。
      </p>
      <p className="mt-2 rounded-md bg-background-100 px-3 py-1 font-mono text-xs text-foreground-400">
        {location.pathname}
      </p>

      <Link
        to="/"
        className="mt-6 inline-flex cursor-pointer items-center gap-1.5 whitespace-nowrap rounded-md bg-primary-500 px-6 py-2.5 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600 dark:text-foreground-950"
      >
        <i className="ri-home-4-line text-base"></i>
        返回首页
      </Link>

      <div className="mt-12 w-full">
        <h2 className="font-heading text-sm font-bold text-foreground-800">猜你想看</h2>
        <div className="mt-4 grid grid-cols-2 gap-3 sm:grid-cols-4">
          {recommended.map((item) => (
            <Link
              key={item.to}
              to={item.to}
              className="flex cursor-pointer flex-col items-center gap-2 rounded-xl border border-background-200 bg-background-50 px-4 py-5 transition-colors hover:border-primary-300 hover:bg-primary-50"
            >
              <span className="flex h-10 w-10 items-center justify-center rounded-full bg-primary-100 text-primary-600">
                <i className={`${item.icon} text-xl`}></i>
              </span>
              <span className="text-sm font-medium text-foreground-700">{item.label}</span>
            </Link>
          ))}
        </div>
      </div>
    </div>
  );
}